export default [
  {
    path: '/real-estate-developments/:id/typologies/new',
    name: 'RealEstateDevelopmentsTypologiesCreate',
    meta: { requiresAuth: true },
    component: () => import('pages/real-estate-developments/tabs/typologies/form/TypologiesForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/typologies/:id/edit',
    name: 'RealEstateDevelopmentsTypologiesEdit',
    meta: { requiresAuth: true },
    component: () => import('pages/real-estate-developments/tabs/typologies/form/TypologiesForm.vue')
  }
]
